import { render, staticRenderFns } from "./IconUser.vue?vue&type=template&id=72267218&scoped=true&"
import script from "./IconUser.vue?vue&type=script&lang=ts&"
export * from "./IconUser.vue?vue&type=script&lang=ts&"
import style0 from "./IconUser.vue?vue&type=style&index=0&id=72267218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72267218",
  null
  
)

export default component.exports